const seedIcons = {
  player: "svg/player-seed.svg",
  server: "svg/server-seed.svg",
  combined: "svg/combined-seed.svg",
};

export default seedIcons;
